<div class="h-full">
    <afcu-loading target="Loading"/>
</div>
